import React from 'react'
import PeopleCard from '../PeopleProfileCard';

const createElements = () => {
  const elements = [];
  const PeopleImagesUrl = [];
  const PeopleName = [''];
  const PeopleEmailId = ['',];
  const PeopleDescription = [``];
  const Link = [
    "",
    "",
    "",
    "",
    "",
  ];

  for (var i=0;i<PeopleName.length;i++){
      elements.push(<PeopleCard key = {i} peopleImagesUrl = {PeopleImagesUrl[i]} peopleName = {PeopleName[i]} peopleEmailId = {PeopleEmailId[i]} peopleDescription = {PeopleDescription[i]} link={Link[i]}/>)
  }
  return elements
}


const AdministrativeAssistant = () => {
  return (
    <div className="album py-2">
      <div className="row">
      {createElements()}
    </div>
  </div>
  )
}

export default AdministrativeAssistant